const PetrolInPakistan = () => {
  return (
    <div>
      <h2>Petrol Prices in Pakistan:</h2>
      <p>
        According to today's conditions, there is some change in petrol prices
        every 15 days. Sometimes it becomes cheap and sometimes it becomes
        expensive but this time petrol prices have broken all records, at this
        time the price of petrol is the highest in the history of Pakistan.
      </p>
      <h2>Petroleum Companies Pakistan:</h2>
      <p>
        The quality of the petrol is determined with the help of its Octane
        number. The Octane number of petroleum shows how well the petrol can
        resist knocking and provide good performance. The following are several
        reputable petroleum providers in Pakistan, are mentioned below:
        <ol style={{ listStyle: "circle" }}>
          <li>Total Parco.</li>
          <li>Hascol Petroleum.</li>
          <li>Pakistan State Oil.</li>
          <li> Shell Pakistan.</li>
          <li>Attock Petroleum Limited.</li>
        </ol>
        The mentioned oil refining companies are responsible for the majority of
        Fuel distribution in Pakistan. Pakistan had a supply of low-grade petrol
        in the country for a long period. While the rest of the world was using
        finer quality fuel in their vehicles. Even you will get shocked to
        listen that most underdeveloped countries had better fuel supplies than
        Pakistan. In the year 2016, Pakistan starts to import better quality
        petrol with a higher research Octane Number 92. Today, In Pakistan most
        petroleum refining companies refine RON 95 or 97 petrol.
      </p>
      <p>
        The mentioned oil refining companies are responsible for the majority of
        Fuel distribution in Pakistan.
      </p>
      <p>
        Pakistan had a supply of low-grade petrol in the country for a long
        period. While the rest of the world was using finer quality fuel in
        their vehicles. Even you will get shocked to listen that most
        underdeveloped countries had better fuel supplies than Pakistan. In the
        year 2016, Pakistan starts to import better quality petrol with a higher
        research Octane Number 92. Today, In Pakistan most petroleum refining
        companies refine RON 95 or 97 petrol.
      </p>
      <h2>Kinds of Fuels in Pakistan</h2>
      <p>
        Petroleum is obtained through fractional distillation of the crude oil.
        However, Petrol prices in Pakistan change frequently and can be found
        easily.
      </p>
      <h4>Compressed Natural Gas (CNG)</h4>
      <p>
        Compressed Natural Gas (CNG) is an environment-friendly fuel option to
        be used in automobiles. The Gas contains compressed methane gas and is
        usually cheaper than petrol and diesel prices. This CNG is an affordable
        alternative. The CNG is most suitable for trucks, buses, and vans, as
        well as for passenger cars if the boot space is not compromised.
      </p>
      <h4>Liquid Petroleum Gas (LPG)</h4>
      <p>
        Liquid Petroleum Gas is used in some specific vehicles, In Pakistan,
        Liquid Petroleum Gas, mostly used in Auto Rickshaws, and kerosene oil is
        only used for home assistance like stoves, lamps etc.
      </p>
      <h4>Diesel</h4>
      <p>
        Diesel is specifically suitable for heavy engine vehicles. Diesel is
        another popular form of fuel that is being used widely across Pakistan.
        Diesel Prices in Pakistan can be found on this particular page.
      </p>
      <h4>High-Octane Petrol Price in Pakistan:</h4>
      <p>
        Pakistan has now officially adopted the Euro V emission standards to
        improve the engine performance of vehicles. Previously in Pakistan, the
        Euro ll Emission standards were back in the year 2012 when the euro ll
        was already outdated.
        <br /> Now, Pakistan has skipped the Euro lll and Euro iV to adopt Euro
        V standards in the year 2020. The Euro V was introduced in the year 2009
        in other countries. Meanwhile, currently, many other countries are
        following the Euro Vl Emission standards. These countries would switch
        to Euro Vll which is expected to be around 2025.
      </p>
    </div>
  );
};

export default PetrolInPakistan;
